export default __webpack_public_path__ + "static/media/mosaic-logo-full-black.9c24aa7f.svg";